import {
    Solicitation,
    SolicitationClient,
    SolicitationClientFields
} from "../../../../../types/solicitation/solicitationData";
import {HttpSolicitation} from "../../../../../http/solicitation/httpSolicitation";
import React, {useEffect, useState} from "react";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {Collapse, Grid, Stack, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {ExpandIconButton} from "../../../../../components/buttons/Buttons";
import CoOwnersDataGrid from "../../../../solicitation-new/steps/components/components-company-data/CoOwnersDataGrid";
import ShareholdersDataGrid
    from "../../../../solicitation-new/steps/components/components-company-data/ShareholdersDataGrid";
import {Client, ClientRelationshipView} from "../../../../../types/client/clientData";
import {HttpClientRelationships} from "../../../../../http/client/httpClient";
import {HttpSolicitationFlow} from "../../../../../http/flow/httpFlow";
import {ClientSolicitationFlow} from "../../../../../types/flow/flowData";
import CompanyEconomicSituationDataGrid
    from "../../../../solicitation-new/steps/components/components-economic-situation/CompanyEconomicSituationDataGrid";
import SuretiesDataDetailTable
    from "../../../../solicitation-new/steps/components/components-sureties-data/SuretiesDataDetailTable";


interface SolicitationSummaryTablesDataProps {
    solicitation: Solicitation,
    client?: Client
}


const SolicitationSummaryTablesData = ({solicitation, client}: SolicitationSummaryTablesDataProps) => {
    const [clientSolicitations, setClientSolicitations] = useState<SolicitationClient[]>([])
    const [expand, setExpand] = useState<boolean>(false)
    const [expandSureties, setExpandSureties] = useState<boolean>(false)
    const [expandCoOwners, setExpandCoOwners] = useState<boolean>(false)
    const [expandFlows, setExpandFlows] = useState<boolean>(false)
    const [clientRelationships, setClientRelationships] = useState<ClientRelationshipView[]>([])
    const [coOwners, setCoOwners] = useState<SolicitationClient[]>([])
    const [flows, setFlows] = useState<ClientSolicitationFlow[]>([])

    useEffect(() => {
        if (client) {
            HttpClientRelationships.getPorIdCliente(client[EntityWithIdFields.Id]).then((r) => setClientRelationships(r))
        }
    }, [client])

    useEffect(() => {
        Promise.all([
            HttpSolicitation.getClientRelatedsByIdSolicitation(solicitation[EntityWithIdFields.Id]),
            HttpSolicitationFlow.getList(solicitation[EntityWithIdFields.Id])
        ]).then(([clientRelateds, flowLst]) => {
            setClientSolicitations(clientRelateds.filter((x) => x[SolicitationClientFields.RelationshipClassificationCode]  === 4))
            setCoOwners(clientRelateds.filter((x) => x[SolicitationClientFields.RelationshipClassificationCode] === 5))
            setFlows(flowLst)
        })
    }, [solicitation])
    
    return (
        <Grid container spacing={3} mt={4}>
            <Grid item md={12} mt={4} ml={3} sx={{
                borderRadius: '0.475rem',
                border: `1px dashed ${grey[300]} !important`,
                padding: '0.75rem !important',
            }}>
                <Stack direction={'row'}
                       justifyContent={'space-between'}
                       alignItems={'center'}
                >
                    <Typography fontSize={18} fontWeight={600}>
                        Composición Accionaria
                    </Typography>
                    <ExpandIconButton
                        onClick={() => setExpand(!expand)}
                        initialExpanded={'expandMore'}
                        tooltipTitle={expand ? 'Contraer' : 'Expandir'}
                    />
                </Stack>
                <Collapse in={expand}>
                    <ShareholdersDataGrid relationships={clientRelationships}/>
                </Collapse>
            </Grid>
            <Grid item md={12} mt={4} ml={3} sx={{
                borderRadius: '0.475rem',
                border: `1px dashed ${grey[300]} !important`,
                padding: '0.75rem !important',
            }}>
                <Stack direction={'row'}
                       justifyContent={'space-between'}
                       alignItems={'center'}
                >
                    <Typography fontSize={18} fontWeight={600}>
                        Cotitulares
                    </Typography>
                    <ExpandIconButton
                        onClick={() => setExpandCoOwners(!expandCoOwners)}
                        initialExpanded={'expandMore'}
                        tooltipTitle={expandCoOwners ? 'Contraer' : 'Expandir'}
                    />
                </Stack>
                <Collapse in={expandCoOwners}>
                    <CoOwnersDataGrid relationships={coOwners}/>
                </Collapse>
            </Grid>
            <Grid item md={12} mt={4} ml={3} sx={{
                borderRadius: '0.475rem',
                border: `1px dashed ${grey[300]} !important`,
                padding: '0.75rem !important'
            }}>
                <Stack direction={'row'}
                       justifyContent={'space-between'}
                       alignItems={'center'}
                >
                    <Typography fontSize={18} fontWeight={600}>
                        Fiadores
                    </Typography>
                    <ExpandIconButton
                        onClick={() => setExpandSureties(!expandSureties)}
                        initialExpanded={'expandMore'}
                        tooltipTitle={expandSureties ? 'Contraer' : 'Expandir'}
                    />
                </Stack>
                <Collapse in={expandSureties}>
                    <SuretiesDataDetailTable sureties={clientSolicitations}/>
                </Collapse>
            </Grid>
            <Grid item md={12} mt={4} ml={3} sx={{
                borderRadius: '0.475rem',
                border: `1px dashed ${grey[300]} !important`,
                padding: '0.75rem !important'
            }}>
                <Stack direction={'row'}
                       justifyContent={'space-between'}
                       alignItems={'center'}
                >
                    <Typography fontSize={18} fontWeight={600}>
                        Situación Económica de la Empresa
                    </Typography>
                    <ExpandIconButton
                        onClick={() => setExpandFlows(!expandFlows)}
                        initialExpanded={'expandMore'}
                        tooltipTitle={expandFlows ? 'Contraer' : 'Expandir'}
                    />
                </Stack>
                <Collapse in={expandFlows}>
                    <CompanyEconomicSituationDataGrid flows={flows}/>
                </Collapse>
            </Grid>
        </Grid>
    )
}


export default SolicitationSummaryTablesData